import { Routes, Route } from 'react-router-dom';
import FlowMeterNew from '../../../pages/manage_database/FlowMeterNew';
import FlowMeterChoice from '../../../pages/manage_database/FlowMeterChoice';
import FlowMeterDelete from '../../../pages/manage_database/FlowMeterDelete';
import FlowMeterRecord from '../../../pages/manage_database/FlowMeterRecord';
import ManageUploadedData from '../../../pages/manage_database/ManageUploadedData';


const FlowMeterRoutes = () => {
    return <Routes>
         <Route 
            path='/new'
            element={<FlowMeterNew />}
          />
          <Route 
            path='/choice'
            element={<FlowMeterChoice />}
          />
          <Route 
            path='/delete'
            element={<FlowMeterDelete />}
          />
          <Route 
            path='/record/:flow_meter_id'
            element={<FlowMeterRecord />}
          />
          <Route
            path='/manage-uploaded-data/:flow_meter_id'
            element={<ManageUploadedData />}
          />
    </Routes>
}

export default FlowMeterRoutes;